import { render, staticRenderFns } from "./sideactivity.vue?vue&type=template&id=057901cb&scoped=true&"
import script from "./sideactivity.vue?vue&type=script&lang=js&"
export * from "./sideactivity.vue?vue&type=script&lang=js&"
import style0 from "./sideactivity.vue?vue&type=style&index=0&id=057901cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057901cb",
  null
  
)

export default component.exports